import React , { useEffect, useState , useContext, useCallback }  from "react";  
import AppContext from '../../shared/components/AppContext';
import {useNavigate, useParams , Link } from "react-router-dom"; 
import { StylesManager, Model } from 'survey-core';
import {useDispatch, useSelector} from 'react-redux';
import { ErrorParse } from "../../shared/handlers/ErrorParse"
import RespondentService  from '../../shared/services/RespondentService';
import { onChangeLoading  } from "../../redux/actions/ActionApp"; 
import { InfoSurvey  } from './RespondentSurveyComponent';
import { useTranslation } from 'react-i18next';
import "../../../styles/Menu.scss";
import ResearchApi from "../../shared/services/ResearchApi";

/**
 * The function is called when the survey is completed.
 */
export default function RespondentSurveyPrivate() {


    const { t } = useTranslation();
    StylesManager.applyTheme("defaultV2");  
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [survey , SetSurvey] = useState(() => new Model());
    const [surveyInfo , SetSurveyInfo] = useState(null);
    const [txtError , SettxtError] = useState('');
    const myContext = useContext(AppContext); 
    const { id_survey , id_respondent , code , visible } = useParams();
    const languageRedux = useSelector(selector => selector.reduceApp.language);

    const LogicPrivate = () => {
        dispatch(onChangeLoading());
        RespondentService.GetSurveyBySurveyIdRespondentId(id_respondent , id_survey ).then(response => { 
            const jsonData = JSON.parse(response.data.content);
            jsonData.locale = languageRedux === 'es' ? 'es' : 'default';
            SetSurvey(() => new Model(jsonData)); 
            SetSurveyInfo(response.data);
            survey.render("surveyIdResponse");
        })
        .catch(error => {
            const erro = ErrorParse(error);
            SettxtError(erro)
            myContext.notify6('alert' , 'Error' , erro); 
        })
        .finally(() => {
            dispatch(onChangeLoading());
        });
    }
    
 
    const alertResults = useCallback((sender) => {
        const results = { "content": JSON.stringify(sender.data)  } ;
        dispatch(onChangeLoading());
        RespondentService.PostAnswerRespondent(id_respondent ,id_survey , code , results ).then(() => {  
            myContext.notify6('success' , t('NOTIFICATIONS.TITLE_INFORMATION') , t('NOTIFICATIONS.SAVED_SURVEY_RESPONSES'));
            navigate('/Survey', { replace: true }); 
        })
        .catch(error => {
            myContext.notify6('alert' , 'Error' ,  ErrorParse(error)); 
        }).finally(() => {
            dispatch(onChangeLoading());
        });
    },[]) ; 

    const researchToken = async () => {
        await ResearchApi(dispatch);
    }
    
    survey.onComplete.add(alertResults); 

    useEffect(() => {  
        if (visible === 'private' ) {
            researchToken().then().finally(() => LogicPrivate());
        } else {
            navigate('/', { replace: true }); 
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        survey.render("surveyIdResponse");
    }, [survey]);

    return (
        <div>
            <p> 
                <Link to="/Survey">{t('RESPONDENT.SURVEY.BACK_SURVEY_LIST')}</Link>
            </p> 
            {
                 surveyInfo && surveyInfo.name ?
                 <div className="context"> 
                    <InfoSurvey surveyInfo={surveyInfo}  survey={survey}  />  
                 </div> 
                 :
                 <>
                     <div className="mt-6 mb-5 font-bold text-6xl text-900 text-center">{txtError}</div>
                 </> 
            }  
        </div>
    );

}
